import { css } from '@emotion/core';

export const errorPageContainerOverrideCSS = css`
    align-items: flex-start;
`;
